module.exports = __webpack_public_path__ + "locales/olympia/en.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=locales/olympia/en.json!./src/webComponents/locales/olympia/en.json
// module id = 256
// module chunks = 2